import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { SourcingTemplatesPage } from '@/areas/sourcing-scenarios/SourcingTemplates/SourcingTemplatesPage';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/next/templates/sourcing/')({
    staticData: { access: { permissions: ['view:sourcing'] }, chrome: 'none' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <SourcingTemplatesPage />;
}
